import { isApiError } from '@/api/api'
import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			gcTime: 1000 * 60 * 60 * 24,
			retry: (failureCount, error) => {
				if (isApiError(error) && [401, 403, 404].includes(error.httpStatusCode)) {
					return false
				}
				return failureCount < 3
			}
		}
	}
})
